export default "__VITE_ASSET__a954da42__"